import { sentryQabConfig } from './sentryConfig';

export const sentryConfigClaims = {
  ...sentryQabConfig,
  dsn: 'https://5c2f839284eb48213616422e05939c26@o207017.ingest.us.sentry.io/4508002691252224',
};
